import { useState } from 'react'
import { numberMask } from '../../commons/masks';

const useForm = (initialFormValues) => {
  const [status, setStatus] = useState('');
  const [stateButton, setStateButton] = useState('');
  const [values, setValues] = useState(initialFormValues);

  const handleInputChange = (e) => {
      const { name, value } = e.target;

      // solucao para um objeto dentro de outro objeto
      let valueA = '';
      if (name.includes("|")) {

        const [object, key] = name.split('|');

        setValues({
          ...values, 
          [object]: {
            ...values[object],
            [key]: value.toUpperCase()
          }
        });

      } else {

        if (name.startsWith("email"))
          valueA = value.toLowerCase();
        else if (name.startsWith("discount"))
          valueA = numberMask(value);
        else if (name.startsWith("password")||
                 name.startsWith("role")||
                 name.startsWith("title")||
                 name.startsWith("answer")||
                 name.startsWith("message")||
                 name.startsWith("url")||
                 name.startsWith("imageUrl"))
          valueA = value;
        else
          valueA = value.toUpperCase();

        setValues({
          ...values, 
          [name]: valueA
        });

      }

  }

  const resetForm = () => {
      setStateButton('');
      setValues(initialFormValues);
  }

  return {
      values,
      setValues,
      status,
      setStatus,
      stateButton,
      setStateButton,
      handleInputChange,
      resetForm
  }
}

export default useForm;
